export default {
      id: "shopping-bag-usage",
      viewBox: "0 0 25 35",
      url: __webpack_public_path__ + "svgs/icons.91fe9319.svg#shopping-bag",
      toString: function () {
        return this.url;
      }
    }